import { IModal } from '@epam/uui-core'
import {
  FlexRow,
  FlexSpacer,
  ModalBlocker,
  ModalFooter,
  ModalHeader,
  ModalWindow,
  Panel,
  ScrollBars,
  Text,
} from '@epam/loveship'
import { ReactNode } from 'react'

export interface IBasicModalWindowModalProps {
  messages: Record<string, string>
  buttons: ((
    modalProps: IModal<string> & IBasicModalWindowModalProps,
    key: number | string
  ) => ReactNode)[]
}

export const BasicModalWindow = (
  modalProps: IModal<string> & IBasicModalWindowModalProps
) => {
  const { messages, buttons } = modalProps

  return (
    <ModalBlocker {...modalProps}>
      <ModalWindow>
        <Panel background="white">
          <ModalHeader
            title={messages.title}
            onClose={() => modalProps && modalProps.abort()}
          />
          <ScrollBars hasTopShadow hasBottomShadow>
            <FlexRow padding="24">
              <Text size="36">{messages.description}</Text>
            </FlexRow>
          </ScrollBars>
          <ModalFooter>
            <FlexSpacer />
            {buttons.map((button, index) => button(modalProps, index))}
          </ModalFooter>
        </Panel>
      </ModalWindow>
    </ModalBlocker>
  )
}
